import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modal-editar-usuario',
  templateUrl: './modal-editar-usuario.component.html',
  styleUrls: ['./modal-editar-usuario.component.css']
})
export class ModalEditarUsuarioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
